import React from 'react'

const HeldToCompareIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 9.00098H15V11.001H5V9.00098Z" fill="#FFBC00" />
      <path
        d="M10 0.000976562C4.486 0.000976562 0 4.48698 0 10.001C0 15.515 4.486 20.001 10 20.001C15.514 20.001 20 15.515 20 10.001C20 4.48698 15.514 0.000976562 10 0.000976562ZM10 18.001C5.589 18.001 2 14.412 2 10.001C2 5.58998 5.589 2.00098 10 2.00098C14.411 2.00098 18 5.58998 18 10.001C18 14.412 14.411 18.001 10 18.001Z"
        fill="#FFBC00"
      />
    </svg>
  )
}

export default HeldToCompareIcon
